import { useEffect, useRef, useMemo } from 'react';
import type { Player, Players, ToneAudioBuffersUrlMap } from 'tone';
// import { useReactAudioContext } from '@tmsw/powerups.audio.provider';
import { useCallbackRef } from '@radix-ui/react-use-callback-ref';
import * as Tone from 'tone';
// @ts-ignore
// window.Tone = Tone;
// interface ToneAudioBuffersOptions {
//   urls: ToneAudioBuffersUrlMap;
//   onload?: () => void;
//   onerror?: (error: Error) => void;
//   baseUrl?: string;
// }

/**
 * @param ToneAudioBuffersOptions
 * @returns
 */
export function useSoundEffects(options: {
  urls: ToneAudioBuffersUrlMap;
  callback?: () => void;
}) {
  // const { addPlayer, players } = useReactAudioContext();

  // const sfxMap = useRef(new Map());
  const playersRef = useRef<Players>(new Tone.Players().toDestination());
  // const playersRef = useRef<Map<string, Player>>(new Map());

  const initSfx = useCallbackRef(() => {
    console.log('useSoundEffects USE MEMO');
    Object.entries(options.urls).forEach(([name, url]) => {
      // const callback = options.callback ?? (() => {});
      if (playersRef.current.has(name)) {
        // if (playersRef.current.get(name)?.disposed) {
        if (playersRef.current.player(name).disposed) {
          // if (typeof url === 'string') {
          // playersRef.current.get(name)?.load(url);
          // playersRef.current.player(name)?.load(url);
          playersRef.current.add(name, url);
          // }
        }
      } else {
        // const player = new Tone.Player(url).toDestination();
        // playersRef.current.set(name, player);
        playersRef.current.add(name, url);
      }
      // playersRef.current.player(name).sync();
      // sfxMap.current.set(name, playersRef.current.player(name));
    });

    return playersRef;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const disposeSfx = useCallbackRef(() => {
    console.log('DISPOSING SFX', playersRef.current);
    // playersRef.current.forEach((player, name) => {
    //   player.dispose();
    //   playersRef.current.delete(name);
    // });
    playersRef.current.dispose();
    // playersRef.current = new Tone.Players().toDestination();
  });

  const playSfx = useCallbackRef((name) => {
    const player = playersRef.current.player(name);
    // const player = playersRef.current.get(name)!;
    // console.log('player', player);
    player.stop().start(0);
  });

  useEffect(() => {
    // hack hack hack
    if (!playersRef.current.has('tilePlacementSuccess')) {
      console.log('INIT SOUND EFFECTS!');
      initSfx();
    }
    // return () => {
    //   disposeSfx();
    // };
  }, []);

  return playSfx;

  // return {
  //   initSfx,
  //   disposeSfx,
  //   playSfx,
  // };
}
